import axios from 'axios';

export default class AuthorityService {
  private static cached: Promise<string[]> | null = null;

  static authorities(): Promise<string[]> {
    if (!this.cached) {
      this.cached = axios.get('/api/v1/me/authorities').then((r) => r.data);
    }
    return this.cached;
  }

  static clearCache(): void {
    this.cached = null;
  }
}
